const AUTH_STORAGE_KEY = 'AUTH_TOKEN';
const AUTH_LAST_EMAIL_KEY = 'AUTH_LAST_EMAIL';
const AUTH_REMEMBER_EMAIL_KEY = 'AUTH_REMEMBER_EMAIL';

export async function saveAuthTokenOnStorage(token: string): Promise<void> {
  localStorage.setItem(AUTH_STORAGE_KEY, token);
}

export async function getAuthToken(): Promise<string> {
  const token = localStorage.getItem(AUTH_STORAGE_KEY);

  if (!token) {
    throw new Error('Not auth token found');
  }

  return token;
}

export async function removeAuthToken(): Promise<void> {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}

export async function saveLoginEmailOnStorage(email: string): Promise<void> {
  localStorage.setItem(AUTH_LAST_EMAIL_KEY, email);
}

export function retriveLoginEmailFromStorage(): string {
  const email = localStorage.getItem(AUTH_LAST_EMAIL_KEY);

  return email ?? '';
}

export function saveRememberEmailOnStorage(remember: boolean): void {
  localStorage.setItem(AUTH_REMEMBER_EMAIL_KEY, remember.toString());
}

export function getRememberEmailFromStorage(): boolean {
  const remember = localStorage.getItem(AUTH_REMEMBER_EMAIL_KEY);
  return remember === 'true';
}

export function removeEmailFromStorage(): void {
  localStorage.removeItem(AUTH_LAST_EMAIL_KEY);
}

export function clearEmailIfNotRemembered(): void {
  const shouldRemember = getRememberEmailFromStorage();
  if (!shouldRemember) {
    removeEmailFromStorage();
  }
}
